
import { randomNumber } from '../helpers'

class RandomImage {
	constructor(el) {
		// Store all relevant DOM nodes of Component
		this.el = el
		this.decoded = atob(this.el.getAttribute('data-images'))

		this.init()
	}

	init() {
		const parser = new DOMParser()
		const html = parser.parseFromString(this.decoded, 'text/html')
		const nodes = html.body.children
		const index = randomNumber(0, nodes.length - 1)
		const selectedNode = nodes[index]

		this.el.appendChild(selectedNode)
	}
}

(function init() {
	const bottleArchEls = document.querySelectorAll('[data-random-image]')

	bottleArchEls.forEach((el, i, arr) => {
		if (el.getAttribute('bound') !== null) return

		const bottleArch = new RandomImage(el, { closeSiblings: true })

		el.setAttribute('bound', '')

		const id = arr.length > 1 ? `bottleArch_${i}` : 'bottleArch'

		self.Decimal.components[id] = { ...bottleArch, async: true }
	})
})()
